import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import './Services.css';

const Terms = () => {
  const { t } = useTranslation();

  return (
    <div className="services-page legal-page">
      <section className="page-hero modern-page-hero">
        <div className="page-hero-pattern"></div>
        <div className="page-hero-overlay"></div>
        <Container>
          <div className="page-hero-content">
            <h1 className="animate-appear">{t('legal.terms.title', 'Términos de Servicio')}</h1>
            <p className="animate-appear">
              {t('legal.terms.subtitle', 'Condiciones que aplican al uso del sitio web y los servicios de ProMedic Group.')}
            </p>
          </div>
        </Container>
      </section>

      <section className="section modern-section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={9}>
              <p className="text-muted mb-4">{t('legal.lastUpdated', 'Última actualización: 2026')}</p>

              <h2 className="h4 mb-3">{t('legal.terms.section1.title', '1. Aceptación de los términos')}</h2>
              <p>{t('legal.terms.section1.text', 'Al acceder y utilizar el sitio web de ProMedic Group ("ProMedic", "nosotros"), usted acepta cumplir estos Términos de Servicio. Si no está de acuerdo con alguna parte de estos términos, le solicitamos no utilizar este sitio.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.terms.section2.title', '2. Descripción del servicio')}</h2>
              <p>{t('legal.terms.section2.text', 'ProMedic ofrece servicios de mantenimiento electromecánico especializados para la industria de dispositivos médicos en Costa Rica. La información publicada en este sitio es de carácter informativo y comercial; no constituye una oferta vinculante hasta la formalización de una cotización o contrato firmado.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.terms.section3.title', '3. Uso del sitio')}</h2>
              <p>{t('legal.terms.section3.text', 'Usted se compromete a utilizar este sitio únicamente con fines lícitos y de una manera que no infrinja los derechos de terceros ni restrinja el uso del sitio por parte de otros usuarios.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.terms.section4.title', '4. Propiedad intelectual')}</h2>
              <p>{t('legal.terms.section4.text', 'Todo el contenido de este sitio (textos, imágenes, marcas y logotipos) es propiedad de ProMedic Group o se utiliza con la debida autorización, y está protegido por las leyes de propiedad intelectual aplicables en Costa Rica.')}</p>

              <h2 className="h4 mb-3 mt-4">{t('legal.terms.section5.title', '5. Contacto')}</h2>
              <p>{t('legal.terms.section5.text', 'Para consultas relacionadas con estos términos, puede escribirnos a')} <a href="mailto:jorge.murillo@promedicgroup.com">jorge.murillo@promedicgroup.com</a>.</p>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default Terms;
